<template>
  <div class="mainContent startConfigWarehouseDiv">
    <div class="mainContent__paragraphs">
      <p>
          Selecione os centros de distribuição que deseja configurar
      </p>
    </div>

    <div class="mainContent__table">
      <sc-warehouses-list
        v-if="loaded"
        ref="warehouseListComponent"
        :editable="true"
        :configurable="false"
      />
    </div>
    <help-button/>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScToast } from '@intelipost-js/secure-components';
import ScWarehousesList from './ScWarehousesList.vue';
import HelpButton from '../base/HelpButton.vue';

const { mapActions, mapState, mapMutations } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);

export default {
  name: 'sc-config-warehouses',
  components: {
    ScWarehousesList,
    HelpButton,
    ScToast,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapState(['appDetails', 'appConfig', 'warehouses', 'includedWarehouses']),
  },
  created() {
    this.setLoading(true);
    this.getWarehouses()
      .then(() => {
        this.loaded = true;
        this.setLoading(false);
      });
  },
  methods: {
    ...mapMutations(['setLoading']),
    ...mapActions(['getWarehouses']),

    validate() {
      if (!this.includedWarehouses || this.includedWarehouses.length === 0) {
        ScToast.open({
          message: 'Adicione pelo menos um Centro de Distribuição',
          duration: 2000,
          type: 'is-danger',
        });
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang='scss' scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 40px;

  &__paragraphs {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    gap: 30px;
    max-width: 500px;
  }

  &__input {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/warehouse/ScConfigWarehouses.vue